import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PublisherForm from "../PublisherForm";
import API from "../../../services/axiosInstance";
import { FormLoader, useFormLoader } from "../../common_modules/loader";
const UpdatePublisher = () =>{
     const { guid } = useParams();
     const [publisherData, setPublisherData] = useState(null);
     // custom hook loader
     const { isLoading, startLoading, stopLoading } = useFormLoader();

     const fetchPublisher = async () => {
        startLoading();
        try {
            const res = await API.get(`/publisher/accounts/${guid}`);
               setPublisherData(res?.data?.data);
        } catch (error) {
            
        } finally {
            stopLoading();
        }
     };    
    
    useEffect(() => {
        fetchPublisher();
    }, [guid]);
    
    const paymentFormMapper = (data) => {
        switch (data.paymentType) {
            case 1:
                return {
                    paymentType:1,
                    paypalId: data.paypalId || ""
                };
            case 2:
                return {
                    paymentType:2,
                    bankBeneficiaryName:data.bankBeneficiaryName || "",
                    bankAccountNo: data.bankAccountNo || "",
                    bankName: data.bankName || "",
                    bankAddress: data.bankAddress || "",
                    bankBranchNo: data.bankBranchNo || "",
                    bankVatNo: data.bankVatNo || "",
                };
            case 3:
                return {
                paymentType: 3,
                wireBeneficiaryName: data.wireBeneficiaryName || "",
                wireAccountNo: data.wireAccountNo || "",
                wireBankName: data.wireBankName || "",
                wireBankAddress: data.wireBankAddress || "",
                swiftCode: data.swiftCode || "",
                iban: data.iban || "",
                };
            default: {
                return {
                    paymentType:0
                };
            }
        }
    }

     if (!publisherData) return null;
     
    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
        <PublisherForm 
        mode="edit"
        publisherId={publisherData?.id}
        publisherGuid={publisherData?.guid}
        defaultValues={{
        name: publisherData.name,
        userId: publisherData.userId,
        email: publisherData.email,
        password:publisherData.password,
        confirmPassword:publisherData.password,
        phone: publisherData.phone,
        contactDetail:publisherData.contactDetail,
        companyName: publisherData.companyName,
        brand: publisherData.brand,
        city: publisherData.city,
        country: publisherData.country,
        address: publisherData.address,
        roleSetList: publisherData.roleSetId,
        payoneerId:publisherData.payoneerId,
        ...paymentFormMapper(publisherData),
        }}/>
        </FormLoader>
    )
}

export default UpdatePublisher;